<div class="loading-animate">&nbsp;</div>
<div class="page">
  <router-outlet></router-outlet>
</div>